// FarmaciaItem.js
import React from 'react';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function FarmaciaItem({ farmacia }) {
  const comunaFormateada = capitalizeFirstLetter(farmacia.comuna_nombre);

  return (
    <div className="FarmaciaItem">
      <h2>{farmacia.local_nombre}</h2>
      <p>Hora Cierre: {farmacia.funcionamiento_hora_cierre}</p>
      <p>Teléfono: {farmacia.local_telefono}</p>
      <p>Dirección: {farmacia.local_direccion}</p>
      <p>Comuna: {comunaFormateada}</p>
      <button onClick={() => llamar(farmacia.local_telefono)}>Llamar</button>
    </div>
  );
}

function llamar(telefono) {
  window.location.href = `tel:${telefono}`;
}

export default FarmaciaItem;
